<template>
  <div>

    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>薪资信息</el-breadcrumb-item>
      <el-breadcrumb-item>上传工资条</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card >
      <div>
        <el-link :underline="false"  target="_blank"  type="info" >Excel工资表中可以任意自定义列名,其中需包含「手机」或「身份证」，「实发金额」  </el-link>
        <el-button type="text"  @click="salaryIntroduceVisible = true">查看示意图</el-button>
      </div>
      <div>
        <el-link :underline="false"  target="_blank"  type="info" >快速体验薪资查询助手功能，请点击 </el-link>
        <el-link type="primary" href="https://hnmykj.oss-cn-hangzhou.aliyuncs.com/xzcx/excel/demo/%E6%B5%8B%E8%AF%95%E8%AF%95%E7%94%A8%E5%B7%A5%E8%B5%84%E6%9D%A1demo.xlsx">下载体验工资条</el-link>
      </div>
      <div>
        <el-link :underline="false"  target="_blank"  type="info" >如果使用有疑问?</el-link>
<!--        <el-link type="primary" href=""></el-link>-->
<!--        -->
        <el-button type="text"  @click="introduceVisible = true">联系客服</el-button>


      </div>

<!--      <div v-if="company.newCompanyStatus == 1">-->
<!--        <el-alert-->
<!--          title="薪资查询助手,新用户免费试用12个月!"-->
<!--          type="warning"-->
<!--          center-->
<!--          show-icon>-->
<!--        </el-alert>-->
<!--      </div>-->
    </el-card>

    <el-dialog
      title=""
      :visible.sync="introduceVisible"
      width="50%">
      <div class="block">
        <el-image src="https://hnmykj.oss-cn-hangzhou.aliyuncs.com/xzcx/images/poster/kefuweixinerweima.gif"></el-image>
      </div>
    </el-dialog>


    <el-dialog
      title=""
      :visible.sync="salaryIntroduceVisible"
      width="55%">
      <div class="block">
        <el-image src="https://hnmykj.oss-cn-hangzhou.aliyuncs.com/xzcx/images/poster/used.png"></el-image>
      </div>
    </el-dialog>

    <!-- 卡片视图 -->
    <el-card>

    <el-steps :active="active" align-center>
      <el-step title="上传" description="">
      </el-step>
      <el-step title="校验" description="">
      </el-step>
      <el-step title="完成" description=" ">
      </el-step>
    </el-steps>



      <!--   企业过期提醒   -->
      <el-dialog
        title="提醒"
        :visible.sync="company.companyExpireDialogVisible"
        width="60%"
      >

        <div>

          <el-alert
            v-if="company.surplusMonth == 2"
            title="续费提醒"
            type="warning"
            description="尊敬的用户，您的权益剩余 2月 到期！为了不影响您的正常使用体验，请尽快完成续订操作。现在续订，即享更多福利！"
            show-icon>
          </el-alert>


          <el-alert
            v-if="company.surplusMonth == 1"
            title="续费提醒"
            type="warning"
            description="尊敬的用户，您的权益剩余 1月 到期！为了不影响您的正常使用体验，请尽快完成续订操作。现在续订，即享更多福利！"
            show-icon>
          </el-alert>

          <el-alert
            v-if="company.surplusMonth <= 0"
            title="续费提醒"
            type="warning"
            description="尊敬的用户，您的权益剩余 本月 到期！为了不影响您的正常使用体验，请尽快完成续订操作。现在续订，即享更多福利！"
            show-icon>
          </el-alert>

          <span slot="footer" class="dialog-footer"/>


          <div style="margin-top: 130px;display: flex;justify-content: center;align-items: center;">
            <el-button type="primary" @click="company.companyExpireDialogVisible = false">知道了</el-button>
            <el-button type="primary" @click="renewOrder">续费</el-button>
          </div>


        </div>



      </el-dialog>


    <div v-if="active == 0">

      <el-divider content-position="left">上传工资表</el-divider>


      <div  style="margin-top: 50px;">


        <el-form ref="form" :model="form" label-width="80px">
<!--          <el-form-item label="编号">-->
<!--            <el-input v-model="form.name"  style="width: 40%"></el-input>-->
<!--          </el-form-item>-->

          <el-form-item label="类型">
            <el-select v-model="form.type"  @change="onChangeType" placeholder="请选择类型">
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.value"
                :value="item.id">
              </el-option>
            </el-select>

            <el-button icon="el-icon-plus" @click="dialogVisibleAddType = true" size="mini" circle />
          </el-form-item>



          <el-dialog title="薪资类型" :visible.sync="dialogVisibleAddType">


            <el-button type="primary" @click="dialogFormVisibleAdd = true">新增</el-button>

            <el-dialog title="新增薪资类型" :visible.sync="dialogFormVisibleAdd"  center  append-to-body>
              <el-form :model="salaryTypeForm">
                <el-form-item label="薪资类型名称"  style="width: 320px">
                  <el-input v-model="salaryTypeForm.value"  maxlength="8" show-word-limit autocomplete="off"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisibleAdd = false">取 消</el-button>
                <el-button type="primary" @click="addSalaryType">确 定</el-button>
              </div>
            </el-dialog>


            <el-table :data="typeList"  max-height="400">
              <el-table-column type = "index" label = "序号"  width="100"></el-table-column>
              <el-table-column property="value" label="名称" width="200"></el-table-column>
              <el-table-column property="companyId" label="来源" width="200">
                <template scope="scope">
                  <p v-if="scope.row.companyId == 0">系统</p>
                  <p v-if="scope.row.companyId != 0">管理员</p>
                </template>
              </el-table-column>
              <el-table-column label = "操作" class = "" v-slot = "scope" width = "130px">

                <el-button v-if="scope.row.companyId != 0" @click = "updateSalaryType(scope.row.id)" type = "primary" icon = "el-icon-edit"
                           size = "mini"></el-button>
                <el-button v-if="scope.row.companyId != 0" @click = "removeSalaryType(scope.row.id)" type = "danger" icon = "el-icon-delete"
                           size = "mini"></el-button>

              </el-table-column>
            </el-table>
          </el-dialog>


          <el-dialog title="修改薪资类型" :visible.sync="dialogFormVisibleEdit"  center  append-to-body>
            <el-form :model="editTypeForm">
              <el-form-item label="薪资类型名称"  style="width: 320px">
                <el-input v-model="editTypeForm.value" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisibleEdit = false">取 消</el-button>
              <el-button type="primary" @click="editSalaryType">确 定</el-button>
            </div>
          </el-dialog>


          <el-form-item label="部门">
            <el-select v-model="form.departmentId"  @change="onChangeDepartment" placeholder="请选择部门">
              <el-option
                v-for="item in departmentList"
                :key="item.departmentId"
                :label="item.departmentName"
                :value="item.departmentId">
              </el-option>
            </el-select>

            <el-tooltip class="item" effect="dark" content="用于区分当月不同模板工资表" placement="right">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </el-form-item>

          <el-form-item label="薪资月份">
            <el-col :span="11">
              <el-date-picker  type="month" placeholder="选择月份" v-model="form.uploadMonth"  value-format="timestamp" style="width: 40%;"></el-date-picker>
            </el-col>
          </el-form-item>

          <el-form-item label="员工签收">

            <el-switch
              v-model="form.signForStatus"
              active-value="1"
              inactive-value="0">
            </el-switch>

            <div v-if="form.signForStatus == 1">
              发送后
              <el-input-number v-model="form.signForDay" @change="handleChange" :min="1" :max="99999" label="天"></el-input-number>

              天自动确认
            </div>

          </el-form-item>

          <el-form-item label="Excel上传"  style="width:700px">
            <el-upload
              class="upload-demo"
              drag
              accept=".xlsx"
              :headers = "headerObj"
              :action="uploadUrl"
              :on-change="excelFileChange"
              :on-success="handleSuccess"
              :on-exceed="excelExceedFile"
              :file-list="uploadExcel.fileList"
              :limit='1'
              >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip" style="font-size: large;font-weight: bolder">
                <i class="el-icon-warning-outline"></i>注意: 请上传excel文件后缀为" .xlsx "文件

                <div v-if="company.newCompanyStatus == 1">
                  <el-link :underline="false"  target="_blank"  type="info" >快速体验薪资查询助手功能，请点击 </el-link>
                  <el-link type="primary" href="https://hnmykj.oss-cn-hangzhou.aliyuncs.com/xzcx/excel/demo/%E6%B5%8B%E8%AF%95%E8%AF%95%E7%94%A8%E5%B7%A5%E8%B5%84%E6%9D%A1demo.xlsx">下载体验工资条</el-link>
                </div>

                <div v-if="company.newCompanyStatus == 1">
                  <el-link :underline="false"  target="_blank"  type="info" >Excel工资表中可以任意自定义列名,其中需包含「手机」或「身份证」，「实发金额」  </el-link>
                  <el-button type="text"  @click="salaryIntroduceVisible = true">查看示意图</el-button>
                </div>

              </div>
            </el-upload>

          </el-form-item>


<!--          <el-form-item>-->
<!--            <el-button type="primary" @click="onSubmit">立即创建</el-button>-->
<!--            <el-button>取消</el-button>-->
<!--          </el-form-item>-->
        </el-form>


      </div>

      <el-button  type="primary" style="margin-top: 12px;" @click="previewUploadSalary">下一步</el-button>

    </div>



    <div v-if="active == 1">
      <el-divider content-position="left">校验</el-divider>

      <div>
        <el-table style="width: 100%" border :data="salaryList"  max-height="350">
          <template v-for="(item,index) in columnList">
            <el-table-column :prop="item.columnNumber" :label="item.categoryName" :key="index" v-if="item.categoryName != 'id'"></el-table-column>
          </template>
        </el-table>



        <div v-if="salaryList.length > 1">
          <el-alert
            title="成功提示的文案"
            type="success">
          </el-alert>
        </div>
      </div>


      <div style="margin-top: 15px;">
        <el-divider content-position="left">选择</el-divider>

        <el-form ref="form" :model="form" label-width="80px">

          <div v-if="autoColumn == 1">
            <el-alert
              title="已识别出员工手机号列、实发薪资列"
              type="success">
            </el-alert>
          </div>



          <el-form-item label="上传模式"  style="font-size: 10px" >
            <el-select v-model="form.columnType" placeholder="请选择">
              <el-option
                v-for="item in columnTypeList"
                :key="item.type"
                :label="item.name"
                :value="item.type">
              </el-option>
            </el-select>

            <el-tooltip class="item" effect="dark" content="推荐「手机号」更便捷更安全" placement="right">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </el-form-item>



            <el-form-item :label="form.columnType == 2 ? '身份证':'手机号'"  style="font-size: 10px" >
              <el-select v-model="form.columnNumberStr" placeholder="请选择">
                <el-option
                  v-for="item in columnList"
                  :key="item.columnNumber"
                  :label="item.categoryName"
                  :value="item.columnNumber">
                </el-option>
              </el-select>

              <el-tooltip class="item" effect="dark" content="Excel中对应手机号的列名" placement="right">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-form-item>

          <el-form-item label="实发薪资">
            <el-select v-model="form.salaryColumnStr" placeholder="请选择">
              <el-option
                v-for="item in columnList"
                :key="item.columnNumber"
                :label="item.categoryName"
                :value="item.columnNumber">
              </el-option>
            </el-select>

            <el-tooltip class="item" effect="dark" content="Excel中对应实发薪资的列名" placement="right">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </el-form-item>


          <el-form-item label="公告">
            <el-input type="textarea" :rows="3" v-model="form.remark"  style="width: 40%;"></el-input>
            <el-tooltip class="item" effect="dark" content="通告将附在工资条上统一向员工展示" placement="right">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </el-form-item>

        </el-form>
      </div>



      <el-dialog
        title="上传失败"
        :visible.sync="uploadSalaryDialogVisible"
        width="60%"
       >
        <el-alert
          title="上传失败 请调整后重新上传Excel薪资单"
          type="warning">
        </el-alert>
        <span slot="footer" class="dialog-footer"/>

        <el-table
          :data="uploadErrorList"
          stripe
          style="width: 100%"  max-height="200">
          <el-table-column
            prop="row"
            label="Excel行数"
            width="150">
          </el-table-column>
          <el-table-column
            prop="column"
            label="Excel列数"
            width="150">
          </el-table-column>
          <el-table-column
            prop="errorRemark"
            label="异常信息"
            width="520">
          </el-table-column>

        </el-table>


        <div style="margin-top: 30px;">
          <el-button type="primary" @click="againUploadExcel">重新上传excel文件</el-button>
        </div>

      </el-dialog>




      <el-button style="margin-top: 12px;" @click="stepUp">上一步</el-button>
      <el-button  type="primary" style="margin-top: 12px;" @click="uploadSalaryExcelV2">下一步</el-button>
    </div>

    <div v-if="active == 2">
      <el-result title="上传成功" subTitle="">
        <template slot="icon">
          <el-image  style="width: 400px;height:300px" src="https://wssbw-images.oss-cn-hangzhou.aliyuncs.com/trademark/web/96e1776c-9027-421e-9f42-4b1be943b53c.png"></el-image>
        </template>
        <template slot="extra">
          <el-button type="primary" size="medium" @click="againUpload">再发一次</el-button>
          <el-button type="primary" size="medium" @click="queryUploadList">查询发送记录</el-button>
        </template>
      </el-result>


<!--      <el-button style="margin-top: 12px;" @click="stepUp">上一步</el-button>-->
<!--      <el-button   type="primary" style="margin-top: 12px;" @click="ok">完成</el-button>-->
    </div>


    </el-card>

 </div>
</template>



<script>
  export default {
    data() {
      return {
        company:{
          newCompanyStatus:0,
          companyExpireDialogVisible:false

        },
        active: 0,
        //上传对象
        form: {
          name: '',
          type: '',
          departmentId: -9999,
          uploadMonth:null,
          remark:'',
          excelUrl:"http://hnmykj.vip/uploadExcel/2022/05/29/58-4cb6db15-c492-4206-b6c9-f331d1cfac8c.xlsx",
          //http://hnmykj.vip/uploadExcel/2022/02/11/58-04a0a70b-95a8-45b1-9a49-68da6814c741.xlsx
          //http://hnmykj.vip/uploadExcel/2022/05/29/58-4cb6db15-c492-4206-b6c9-f331d1cfac8c.xlsx
          // excelUrl:"",
          columnType:1,//默认是手机号模式 新版不在支持身份证模式
          columnNumberStr:null,
          salaryColumnStr:null,
          signForStatus:0,
          signForDay:2
        },

        //新增对象
        salaryTypeForm:{
          id:0,
          type:1,
          value:""
        },
        //修改薪资类型对象
        editTypeForm:{
          id:null,
          type:1,
          value:""
        },
        //初始化对象
        departmentList:[
          {"departmentId":-9999,"departmentName":"全部"}
        ],
        typeList:[
        ],
        dialogVisibleAddType:false,
        dialogFormVisibleAdd:false,
        dialogFormVisibleEdit:false,
        introduceVisible:false,
        salaryIntroduceVisible:false,
        //excel上传
        uploadExcel:{
          visible:false,
          type:'',
          fileList: [],   // excel文件列表
        },
        // 图片上传组件的headers 请求头
        headerObj: {
          accessToken: window.localStorage.getItem('token')
        },
        uploadUrl:this.$http.defaults.baseURL+"upload/uploadExcel",

        //显示excel详情信息
        autoColumn:0,//自动识别列是否成功
        columnList:[],// 表格数据
        salaryList: [],
        columnTypeList: [
          {
            type:1,
            name:"手机号"
          },{
            type:2,
            name:"身份证"
          }
        ],
        //上传结果
        uploadSalaryDialogVisible:false,
        uploadErrorList:[]
      };
    },

    methods: {
      next() {
        if (this.active++ > 2) this.active = 0;
      }
      ,
      stepUp() {
          this.active--
      },
      async getDepartmentList(){
        const { data: res } = await this.$http.get('department/v2/queryDepartmentPageList?page=1&limit=999')   //get参数用params获得
        console.log(res);
        if(res.code !== '10000') {
          return this.$message.error(res.msg);
        }

        res.data.list.splice(0, 0, {"departmentId":-9999,"departmentName":"全部"})
        this.departmentList = res.data.list;
      },
      onChangeDepartment(){
        console.log(this.form.departmentId)
      },
      async getTypeList(){
        const { data: res } = await this.$http.get('dictionary/findAll?type=1&page=1&limit=999')   //get参数用params获得
        console.log(res);
        if(res.code !== '10000') {
          return this.$message.error(res.msg);
        }
        this.typeList = res.data.list;
      },
      onChangeType(){
        console.log(this.form.type)
      },
      excelFileChange(file) {
        // console.log(file.raw);
        // this.fileList.push(file.raw) ;
        // console.log(this.fileList);
      },
      // 文件超出个数限制时的钩子
      excelExceedFile(files, fileList) {
        this.$message.warning(`最多时能上传一个文件!`);
      },
      // 文件上传成功时的钩子
      handleSuccess(res, file, fileList) {
        console.log(res);
        this.form.excelUrl =  res.data.filePath;
        this.$message.success('文件上传成功');

        console.log(this.form)
      },
      //预先检查
      async previewUploadSalary(){
        if(this.form.type == ''){
          this.$message.error('类型不能为空!');
          this.$notify.error({
            title: '错误',
            message: '类型不能为空!',
            duration: 3000
          });
          return ;
        }
        if(this.form.uploadMonth == null){
          this.$message.error('薪资月份不能为空!');
          this.$notify.error({
            title: '错误',
            message: '薪资月份不能为空!',
            duration: 3000
          });
          return ;
        }
        if(this.form.excelUrl == ''){
          this.$message.error('Excel上传不能为空!');
          this.$notify.error({
            title: '错误',
            message: 'Excel上传不能为空!',
            duration: 3000
          });
          return ;
        }


        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        setTimeout(() => {
          loading.close();
        }, 10000);

        const { data: res } = await this.$http.post('/salaryExcel/previewUploadSalary',this.form)   //get参数用params获得
        console.log(res);
        if(res.code !== '10000') {
          return this.$message.error(res.msg);
        }

        this.autoColumn = res.data.autoColumn;
        this.columnList = res.data.columnList;
        this.salaryList = res.data.salaryList;
        //因为是数字不能直接动态匹配
        this.form.columnNumberStr = res.data.columnNumberStr;
        this.form.salaryColumnStr = res.data.salaryColumnStr;

        loading.close();

        this.active = 1
      },
      async uploadSalaryExcelV2(){
        if(this.form.type == ''){


          this.$message.error('类型不能为空!');
          this.$notify.error({
            title: '错误',
            message: '类型不能为空!',
            duration: 3000
          });
          return ;
        }
        if(this.form.uploadMonth == null){
          this.$message.error('薪资月份不能为空!');
          this.$notify.error({
            title: '错误',
            message: '薪资月份不能为空!',
            duration: 3000
          });
          return ;
        }
        if(this.form.excelUrl == ''){
          this.$message.error('Excel上传不能为空!');
          this.$notify.error({
            title: '错误',
            message: 'Excel上传不能为空!',
            duration: 3000
          });
          return ;
        }

        if(this.form.columnNumberStr == null || this.form.columnNumberStr ==''){
          this.$message.error('手机号不能为空!');
          this.$notify.error({
            title: '错误',
            message: '手机号不能为空!',
            duration: 3000
          });
          return ;
        }

        if(this.form.salaryColumnStr == null || this.form.salaryColumnStr ==''){
          this.$message.error('实发薪资不能为空!');
          this.$notify.error({
            title: '错误',
            message: '实发薪资不能为空!',
            duration: 3000
          });
          return ;
        }

        const { data: res } = await this.$http.post('/salaryExcel/uploadSalaryExcelV2',this.form)   //get参数用params获得
        console.log(res);
        if(res.code == '10011'){
          this.uploadSalaryDialogVisible = true;
          this.uploadErrorList = res.data;

          this.uploadErrorList.forEach(function (item) {
            item.column++;
          });
          return ;
        }

        if(res.code !== '10000') {

          this.$message.error(res.msg);

          this.$notify.error({
            title: '错误',
            message: res.msg,
            duration: 3000
          });
          return ;
        }


        window.localStorage.setItem('signForStatus', this.form.signForStatus);
        window.localStorage.setItem('signForDay', this.form.signForDay);


        if (this.active++ > 2) this.active = 0;
      },
      queryUploadList(){
        //
        this.$router.push({ path: "/salary/salaryList"})
      },
      againUpload(){
        this.active=0;

        this.form.excelUrl = '';
        this.form.type = '';
        this.form.departmentId = -9999;
        this.form.uploadMonth = null;
        this.form.remark = null;
        this.form.columnNumberStr = null;
        this.form.salaryColumnStr = null;
        this.columnList = [];
        this.salaryList = [];
      },
      againUploadExcel(){
        this.active = 0;
        this.uploadSalaryDialogVisible = false;
      },
      //新增薪资类型
      async addSalaryType(){
        const { data: res } = await this.$http.post('/dictionary/add',this.salaryTypeForm)   //get参数用params获得
        if(res.code !== '10000') {
          return this.$message.error(res.msg);
        }

        this.$message.success("新增成功!");
        this.dialogFormVisibleAdd = false;
        this.salaryTypeForm.value = '';
        this.getTypeList();
      },
      //修改薪资类型
      async updateSalaryType(id){
        const {data: res} =  await this.$http.get('dictionary/findDictionaryById?id=' + id)
        if(res.code !== '10000'){
          return this.$message.error(res.msg);
        }
        this.editTypeForm = res.data;
        this.dialogFormVisibleEdit = true;
      },  //修改薪资类型
      async editSalaryType(){
        const { data: res } = await this.$http.post('/dictionary/update',this.editTypeForm)   //get参数用params获得
        if(res.code !== '10000') {
          return this.$message.error(res.msg);
        }
        this.$message.success("修改成功!");
        this.dialogFormVisibleEdit = false;
        this.getTypeList();
      },
      async removeSalaryType(id){
        const confirmResult = await this.$confirm(            //promise  用await
          '此操作将永久删除该类型, 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).catch(err => err)
        // 点击确定 返回值为：confirm
        // 点击取消 返回值为： cancel
        if (confirmResult !== 'confirm') {
          return ;
        }

        let deleteForm ={};
        deleteForm.id = id;

        const { data: res } = await this.$http.post('/dictionary/delete',deleteForm);

        if (res.code !== '10000') return this.$message.error(res.msg);
        this.$message.success('删除成功！')
        this.getTypeList();

      },
      async getCompany(){
        const { data: res } = await this.$http.post('company/queryCompanyData',{})   //get参数用params获得
        if(res.code !== '10000') {
          return this.$message.error(res.msg);
        }
        this.company = res.data;
      },
      async renewOrder(){
        this.$router.push('/Order');
      },
      /**
       * 获取用户上一次的配置值
       */
      getInitData(){
        const signForStatus =  window.localStorage.getItem('signForStatus');
        const signForDay =  window.localStorage.getItem('signForDay');
        if(signForStatus === null){
          this.form.signForStatus = 0;
          this.form.signForDay = 2;
        }else{
          this.form.signForStatus = signForStatus;
          this.form.signForDay = signForDay;
        }


      }
    },
    created () {
      this.getDepartmentList();
      this.getTypeList();
      this.getCompany();
      this.getInitData();


    },
  }
</script>
<style lang="less" scoped>

  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

</style>



// WEBPACK FOOTER //
// src/components/salary/SalaryUpload.vue